import {createApi,fetchBaseQuery} from  '@reduxjs/toolkit/query/react'

const  cryptoApiHeaders ={
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': 'cdc7b3c198msh452eee1f1cfc09cp1e4a5ajsn02af502771b3'
}

const basedUrl='https://coinranking1.p.rapidapi.com';

const createRequest=(url)=>({url, headers :cryptoApiHeaders})

export const cryptoApi= createApi({
    reducerPath: 'cryptoApi',
    baseQuery  : fetchBaseQuery({baseUrl:basedUrl}),
    endpoints  : (builder)=>({
        getCryptos: builder.query({
        query:(count)=>createRequest(`/coins?limit=${count}`)
        }) ,
        getCryptoDetails: builder.query({
            query: (coinId) => createRequest(`/coin/${coinId}`),
          }),

        getCryptoHistory: builder.query({
            query: ({ coinId, timeperiod }) => createRequest(`coin/${coinId}/history?timeperiod=${timeperiod}`),
          }),
      
    })
});

export const {useGetCryptosQuery,
    useGetCryptoDetailsQuery,
    useGetCryptoHistoryQuery} = cryptoApi;